import React, { Fragment, useContext, useEffect, useLayoutEffect } from "react";
import { mapLayer } from "../../common/Modal/NaverMap";
import styled from 'styled-components';
import { checkName, stringToTelNo } from './../../../modules/utils/CheckLogic';
import {IC}  from "../../../resources/Assets";
import Metro from "../../../resources/images/icon/newIcon/metro-location.svg";
import IconPhone from "../../../resources/images/icon/newIcon/Icon awesome-phone.svg";
import { AppContext } from "../../../components/AppProvider";

export default props => {
  const { searchType, data, setLocationInfo, settingTrgtList, connectEvent } =
    props;

  useEffect(() => {
    $(".submitTargets").removeClass("on");
  }, [data]);

  return (
    <ContentsDiv>
      <FlexDiv>
        <HospitalInfo data={data} setLocationInfo={setLocationInfo} />
        <BtnConnect onClick={() => connectEvent(data.hsptKey, data.hsptNm)} />
      </FlexDiv>
    </ContentsDiv>
  );
};

const HospitalInfo = props => {
  const { data, setLocationInfo } = props;
  const { phonecfg } = useContext(AppContext);
  return (
    <div style={{ width: "70%" }}>
      <FlexDiv>
        <ListTitle>
          {checkName(data.hsptNm, 9, 9)} ({data.address2})
        </ListTitle>
        <div>
          <img
            src={Metro}
            onClick={() => mapLayer(phonecfg, setLocationInfo, data)}
            style={{ width: "12px", height: "19px", marginLeft: "8px" }}
          />
        </div>
      </FlexDiv>

      <ListData style={{ width: "70%", wordBreak: "break-all" }}>
        {data.address3} {data.address4}
      </ListData>

      <FlexDiv>
        {data.phone && (
          <Fragment>
            <div>
              <img
                src={IconPhone}
                style={{ width: "10px", height: "10px", marginRight: "8px" }}
              />
            </div>

            <ListData style={{ marginRight: "8px" }}>
              {stringToTelNo(data.phone)}
            </ListData>
          </Fragment>
        )}
        {/* <RoundDivPp>연동가능</RoundDivPp>

          <RoundDivPp>{data.profUseYn === "Y" ? "제증명신청가능" : "제증명신청불가"}</RoundDivPp> */}
      </FlexDiv>

      <FlexDiv>
        <RoundDivPp>연동가능</RoundDivPp>
        <RoundDivPp>
          {data.profUseYn === "Y" ? "제증명신청가능" : "제증명신청불가"}
        </RoundDivPp>
      </FlexDiv>
    </div>
  );
};

const ListTitle = styled.div`
  text-align: left;
  font: normal normal bold 16px/20px Pretendard;
  letter-spacing: 0px;
  color: #00000099;
`;

const ListData = styled.div`
  text-align: left;
  font: normal normal normal 12px/20px Pretendard;
  font-weight: 600;
  letter-spacing: 0px;
  color: #00000099;
`;

const BtnConnect = ({ onClick }) => {
  return (
    <BtnDiv style={{ marginLeft: "auto" }} onClick={onClick}>
      연동
    </BtnDiv>
  );
};

const ContentsDiv = styled.div`
  border: 1px solid #0000001f;
  border-radius: 8px;
  padding: 14px 21px;
  margin-bottom: 16px;
`;

const FlexDiv = styled.div`
  display: flex;
`;

const BtnDiv = styled.div`
  background-color: #b8b8b8;
  color: #fff;
  border-radius: 20px;
  // width: 20%;
  width: 70px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  margin: auto 0 auto auto;
`;

const RoundDivPp = styled.div`
  text-align: center;
  font: normal normal bold 8px/10px Pretendard;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  background-color: #a5aee5;
  border-radius: 20px;
  margin: auto 0px auto 0px;
  // width: 54px;
  padding: 0px 8px;
  margin-right: 4px;
  height: 16px;
  line-height: 16px;
`;